import ActionTypes from './ActionTypes';
import { unwrapResult } from '@reduxjs/toolkit';
// TODO: update this
import store from '../src/store';
import { preferenceActions } from '../src/store';

export function GetPreferenceActionAsync(payload) {
  return (dispatch) => {
    const siteCode = payload;
    return store.dispatch(preferenceActions.getPreferencesForSite(siteCode)).then((response) => {
      const data = unwrapResult(response);
      if (data) dispatch(GetPreferenceAction(data));
    });
    // .catch(err => {
    //   console.log('preference log err...')
    //   console.log(err)
    // })
    // let data = await getUserPreferences(payload)
    // return new Promise((resolve, reject) => {
    //   resolve(getUserPreferences(payload))
    // }).then(res => dispatch(GetPreferenceAction(res)))
  };
}

export function GetPreferenceAction(payload) {
  return {
    type: ActionTypes.GET_PREFERENCE,
    payload,
  };
}
